var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIcons.js
import * as React from 'react';
import IconContainer from '../IconContainer.js';

function ExternalBankIcon(props) {
  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.175 3.516a.252.252 0 00-.292 0l-.006.005-12.984 8.956h26.272l-12.99-8.961zm.86-1.228a1.753 1.753 0 00-2.013 0L1.368 11.706l-.005.004a1.247 1.247 0 00.703 2.267h27.926a1.247 1.247 0 00.703-2.267l-13.66-9.422z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.35 12.793a.75.75 0 01.75.75v12.89a.75.75 0 11-1.5 0v-12.89a.75.75 0 01.75-.75zM10.167 12.793a.75.75 0 01.75.75v12.89a.75.75 0 11-1.5 0v-12.89a.75.75 0 01.75-.75zM15.993 12.793a.75.75 0 01.75.75v12.89a.75.75 0 11-1.5 0v-12.89a.75.75 0 01.75-.75zM21.819 12.793a.75.75 0 01.75.75v12.89a.75.75 0 11-1.5 0v-12.89a.75.75 0 01.75-.75zM27.645 12.793a.75.75 0 01.75.75v12.89a.75.75 0 11-1.5 0v-12.89a.75.75 0 01.75-.75zM.827 29.169a.75.75 0 01.75-.75h28.904a.75.75 0 010 1.5H1.577a.75.75 0 01-.75-.75z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.182 26.432a.75.75 0 01.75-.75h26.194a.75.75 0 010 1.5H2.932a.75.75 0 01-.75-.75z",
      fill: "currentColor"
    })))
  }));
}

export default ExternalBankIcon;